// @ts-nocheck
/**
 * YMQ Custom — Main Entry Point
 *
 * ⚠️ File này PHẢI được load CUỐI CÙNG (sau các file ymq-*.js khác).
 *
 * Nhiệm vụ:
 *  - Đợi DOMContentLoaded
 *  - Lấy các element DOM cần thiết (ymqBox, ATC button, quantity, wishlist...)
 *  - Gọi lần lượt các module:
 *      buildCustomModal       → dựng modal + sync ATC + di chuyển addon/quote-price
 *      watchEstimateBlock     → inject estimate metafield block vào modal
 *      syncYmqModal           → đồng bộ scroll với YMQ built-in modal
 *      autoSelectShippingFee  → tự chọn phí ship theo địa chỉ customer
 *      watchAddressGroup      → khóa ATC + hiển thị prompt khi address chưa xong
 *
 * Phụ thuộc:
 *  - 1-ymq-namespace.js
 *  - 2-ymq-modal.js
 *  - 3-ymq-shipping-fee.js
 *  - 4-ymq-address-validator.js
 */

(function () {
  const YMQCustom = window.YMQCustom;
  if (!YMQCustom) {
    console.error(
      "[YMQCustom] Namespace chưa được khởi tạo. Hãy load 1-ymq-namespace.js trước.",
    );
    return;
  }

  function markBuyReady() {
    document.documentElement.classList.remove("ymq-buy-pending");
    document.documentElement.classList.add("ymq-buy-ready");
  }

  function waitForElement(selector, timeout = 8000) {
    const existing = document.querySelector(selector);
    if (existing) return Promise.resolve(existing);

    return new Promise((resolve) => {
      let settled = false;
      const finish = (el) => {
        if (settled) return;
        settled = true;
        observer.disconnect();
        resolve(el);
      };
      const observer = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) finish(el);
      });
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
      setTimeout(() => finish(document.querySelector(selector)), timeout);
    });
  }

  async function init() {
    const realAtcBtn = await waitForElement(
      'button[name="add"].add-to-cart-button',
      4000,
    );
    if (!realAtcBtn) {
      markBuyReady();
      return;
    }

    const ymqBox =
      document.querySelector("ymq-option") ||
      (await waitForElement("ymq-option", 8000));
    if (!ymqBox) {
      markBuyReady();
      return;
    }

    if (YMQCustom._modalBuilt) {
      moveFormCheckAddress(YMQCustom.addressFormSlot);
      markBuyReady();
      return;
    }
    YMQCustom._modalBuilt = true;
    document
      .querySelectorAll(".ymq-btn-row, .ymq-custom-modal-wrapper")
      .forEach((el) => el.remove());

    const quantityWrapper = document.querySelector(
      ".quantity-selector-wrapper",
    );
    const wishlistButton = document.querySelector(".wishlist-button");
    const wishlistWrapper = wishlistButton ?? null;
    const changeStateWrapper = document.querySelector(
      ".ymq-button-change-state-modal-wrapper",
    );

    const { modalBox, openPopup, closePopup, addressFormSlot } =
      YMQCustom.buildCustomModal({
        ymqBox,
        realAtcBtn,
        quantityWrapper,
        wishlistWrapper,
        changeStateWrapper,
      });
    YMQCustom.watchEstimateBlock(modalBox);
    YMQCustom.syncYmqModal(openPopup, closePopup);
    YMQCustom.autoSelectShippingFee();

    YMQCustom.watchAddressGroup();
    YMQCustom.watchWaitingParentSelects?.();
    YMQCustom.applyQuoteProductState?.();

    moveFormCheckAddress(addressFormSlot);
    markBuyReady();
  }

  /**
   * Đưa <form-check-address> vào .ymq-address-form-slot (sibling của ymq-option
   * trong modal left col) — không inject vào .select-address-group để tránh
   * bị YMQ replace DOM.
   */
  function moveFormCheckAddress(addressFormSlot) {
    const formCheck = document.querySelector("form-check-address");
    const slot =
      addressFormSlot ||
      YMQCustom.addressFormSlot ||
      document.querySelector("[data-ymq-address-form-slot]");
    if (!formCheck || !slot) return;

    if (formCheck.parentElement !== slot) {
      slot.appendChild(formCheck);
    }
    formCheck.classList.remove("hidden");
  }

  YMQCustom.moveFormCheckAddress = moveFormCheckAddress;
  YMQCustom.init = init;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
